import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import css from "./DataExtractAccessibleTabs.css";
import {Tab, TabList, TabPanel} from "react-tabs";
import Reports from "./Reports";
import ManageAccessKeys from "./ManageAccessKeys";
import AccessibleTabs from "../common/AccessibleTabs";

/**
 * Displays the accessible tabs on the Data Extracts Tenant Admin Page.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The component containing the accessible tabs on the Data Extracts Tenant Admin Page.
 */
const DataExtractAccessibleTabs = (props) => {

    const tabsRef = useRef(null);

    return <AccessibleTabs
        defaultFocus
        selectedIndex={props.selectedTabIndex}
        onSelect={nextIndex => {
            props.setSelectedTabIndex(nextIndex)
        }}
        domRef={ref => {
            tabsRef.current = ref
        }}
        className={css['tabs-container']}
        disabledTabClassName={css['tab-disabled']}
        selectedTabClassName={css['tab-selected']}
        selectedTabPanelClassName={css['padding']}>
        <TabList className={css['list-container']}>
            <Tab disabled={false}>Files</Tab>
            <Tab disabled={false}>Access Keys</Tab>
        </TabList>
        <TabPanel>
            <Reports reportsList={props.reportList}
                     onReportChange={props.onReportChange}
                     onSelectAllChange={props.onSelectAllChange}
                     setIsOpen={props.setIsOpen}
                     saveReports={props.saveReports}
            />
        </TabPanel>
        <TabPanel>
            <ManageAccessKeys isOpenNewAccessKey={props.isOpenNewAccessKey}
                              setIsOpenNewAccessKey={props.setIsOpenNewAccessKey}
                              selectedOption={props.selectedOption}
                              setSelectedOption={props.setSelectedOption}
                              onNewAccessKeyCancel={props.onNewAccessKeyCancel}
                              createUser={props.createUser}
                              userCreated={props.userCreated}
                              userCredentials={props.userCredentials}
                              userList={props.userList}
                              setIsOpenDeleteAccessKey={props.setIsOpenDeleteAccessKey}
                              setDeleteUserName={props.setDeleteUserName}
                              maxAccessKeys={props.maxAccessKeys}
                              showSecretKey={props.showSecretKey}
                              onClickShowSecretKey={props.onClickShowSecretKey}
                              setIsOpenUpdateAccessKeyStatus={props.setIsOpenUpdateAccessKeyStatus}
                              onAccessKeyStatusChange={props.onAccessKeyStatusChange}
            />
        </TabPanel>
    </AccessibleTabs>
}

DataExtractAccessibleTabs.propTypes = {
    selectedTabIndex: PropTypes.number.isRequired,
    setSelectedTabIndex: PropTypes.func.isRequired,
    reportList: PropTypes.arrayOf(PropTypes.object),
    onReportChange: PropTypes.func.isRequired,
    onSelectAllChange: PropTypes.func.isRequired,
    isOpenNewAccessKey: PropTypes.bool.isRequired,
    setIsOpenNewAccessKey: PropTypes.func.isRequired,
    selectedOption: PropTypes.object,
    setSelectedOption: PropTypes.func.isRequired,
    onNewAccessKeyCancel: PropTypes.func.isRequired,
    createUser: PropTypes.func.isRequired,
    userCreated: PropTypes.bool.isRequired,
    userCredentials: PropTypes.object,
    userList: PropTypes.arrayOf(PropTypes.object),
    setIsOpenDeleteAccessKey: PropTypes.func.isRequired,
    setDeleteUserName: PropTypes.func.isRequired,
    maxAccessKeys: PropTypes.number.isRequired,
    showSecretKey: PropTypes.bool.isRequired,
    onClickShowSecretKey: PropTypes.func.isRequired,
    setIsOpenUpdateAccessKeyStatus: PropTypes.func.isRequired,
    onAccessKeyStatusChange: PropTypes.func.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    saveReports: PropTypes.func.isRequired
};

export default DataExtractAccessibleTabs;
